import { useCallback, useState } from "react";

import { useGlobalEvent } from "../../../common/hooks/useGlobalEvent";
import {
	useCartActions,
	useCartContext,
} from "../../../contexts/CartServiceContext/CartServiceContext";
import { useConfigContext } from "../../../contexts/ConfigContext/ConfigContext";
import { CART_PAGE_EVENT } from "../constants";

export const useDineInTakeawayButton = () => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const { state: takeaway_fee } = useConfigContext((state) => state.config.takeaway_fee);
	const { state: cart } = useCartContext((state) => state);
	const actions = useCartActions();

	const takeawayOption = useCallback(() => {
		actions.TAKEAWAY(takeaway_fee);
	}, [actions, takeaway_fee]);

	const dineInOption = useCallback(() => {
		actions.DINEIN();
	}, []);

	const showOption = useCallback(() => {
		setIsOpen(true);
	}, []);

	const hideOption = useCallback(() => {
		setIsOpen(false);
	}, []);

	const updateDiningOption = useCallback(
		(takeaway: boolean) => {
			if (takeaway) {
				takeawayOption();

				return;
			}
			dineInOption();
		},
		[takeawayOption]
	);

	useGlobalEvent(CART_PAGE_EVENT.CHANGE_DINEIN_TAKEAWAY, updateDiningOption);

	return {
		takeaway: cart.is_takeaway,
		fee: takeaway_fee,
		takeawayOption,
		dineInOption,
		showOption,
		hideOption,
		isOpen,
	};
};
